import React from 'react';
import { Box, ColumnConfig, DataTable as DTable, Stack } from 'grommet';
import { Spinner } from './Spinner';

const options = {
  background: {
    header: 'dark-2',
    body: ['white', 'light-2'],
    footer: 'dark-3',
  },
  fill: false,
  sortable: false,
  size: 'large',
};

const DataTable = ({
  columns,
  data,
  loading,
}: {
  columns: ColumnConfig<object>[];
  data: object[];
  loading: boolean;
}) => (
  <Stack anchor="center">
    <DTable
      {...options}
      columns={columns}
      data={data}
      step={data.length}
      style={{ opacity: loading ? 0.5 : 1 }}
      sort={{ direction: 'asc', external: true, property: 'name' }}
    />
    {loading && data.length !== 0 && (
      <Box pad="medium" round="medium">
        <Spinner />
      </Box>
    )}
  </Stack>
);

export { DataTable };
